module.exports = __webpack_public_path__ + "static/media/avatar.e081712d.svg";